import { render, staticRenderFns } from "./ShopSorting.vue?vue&type=template&id=fab7ff46&scoped=true"
import script from "./ShopSorting.vue?vue&type=script&lang=js"
export * from "./ShopSorting.vue?vue&type=script&lang=js"
import style0 from "./ShopSorting.vue?vue&type=style&index=0&id=fab7ff46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab7ff46",
  null
  
)

export default component.exports